export const customerConsortiumChannelOptions = [
  { label: 'Push', value: 'push', disabled: true },
  { label: 'Whatsapp', value: 'whatsapp' },
];

export const customerConsortiumRadioOptions = [
  { label: 'Sim, quero participar', value: '1' },
  { label: 'Não desejo participar', value: '0' },
];

export const customerConsortiumChannelsSelected = customerConsortiumChannelOptions
  .filter((option) => !option.disabled && option.value)
  .map((option) => option.value);

export const customerConsortiumRadioOptionSelected = customerConsortiumRadioOptions[0].value;
